import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Row, Col } from 'react-flexbox-grid';

import FormSection from 'containers/FormSectionContainer';
import FormField from 'containers/FormField';
import FormProvider from 'routes/Documents/containers/FormProvider';
import InfoField from 'routes/Documents/components/InfoField';

import ScaleField from './ScaleField';
import { nowPartialDate } from 'neuro-utils';

const EQ5DForm = props => {
  const isInDialog = props.isDialog;

  // Effect to set 'date' field as current date in partial form when creating a new EQ-5D form
  React.useEffect(() => {
    if (!props.formValues.date && props.editing && Object.keys(props.initialValues).length === 0) {
      props.change('date', nowPartialDate());
    }
  }, []);

  return (
    <FormProvider {...props}>
      <FormSection>
        <InfoField viewStyle={{ marginBottom: '3rem' }}>
          <Row start="sm" center="xs">
            <Col xs={9}>
              <b>
                <FormattedMessage id="eq5d.info.1" />
              </b>
            </Col>
          </Row>
          <Row start="sm" center="xs">
            <Col xs={9}>
              <FormattedMessage id="eq5d.info.2" />
            </Col>
          </Row>
        </InfoField>
      </FormSection>
      <FormSection>
        <FormField
          name="sections"
          component={ScaleField}
          instrument="eq5d"
          sectionNames={[
            'mobility',
            'selfcare',
            'usualActivities',
            'painDiscomfort',
            'anxietyDepression',
            'yourHealthToday',
          ]}
          isInDialog={isInDialog}
        />
      </FormSection>
    </FormProvider>
  );
};

export default EQ5DForm;
